import React from 'react';
import styles from './FilterGroup.module.css';

interface FilterGroupProps {
  className?: string;
  children: React.ReactNode;
}

const FilterGroup: React.FC<FilterGroupProps> = ({ className = '', children }) => {
  const cls = [styles['filter-group'], className].filter(Boolean).join(' ');
  return <div className={cls}>{children}</div>;
};

export default FilterGroup;
